<template>
  <v-app-bar flat class="border-b" color="surface">
    <template v-slot:prepend>
      <v-app-bar-nav-icon
          v-if="mobile"
          @click.stop="drawer = !drawer"/>
    </template>

    <v-app-bar-title class="text-body-1 d-flex align-center ml-0 pl-0">
        <Logo width="140" class="mr-2"/>
    </v-app-bar-title>

    <v-spacer></v-spacer>

    <v-no-ssr>
      <v-menu
          v-model="notificationMenu"
          :close-on-content-click="false"
          width="500"
          max-height="700"
          transition="none">
        <template v-slot:activator="{ props }">
          <v-tooltip text="Notifications" location="bottom">
            <template v-slot:activator="{ props: tooltip }">
              <v-btn icon v-bind="mergeProps(props, tooltip)" class="text-none notification-btn">
                <v-badge v-if="user?.unread_alerts_count"
                         color="error"
                         :content="user.unread_alerts_count"
                         max="9"
                         class="notification-badge">
                  <v-icon>{{ notificationMenu ? 'mdi-bell' : 'mdi-bell-outline' }}</v-icon>
                </v-badge>
                <v-icon v-else>{{ notificationMenu ? 'mdi-bell' : 'mdi-bell-outline' }}</v-icon>
              </v-btn>
            </template>
          </v-tooltip>
        </template>

        <NotificationCard max-width="550"/>
      </v-menu>


      <v-menu
          eager
          v-model="menu"
          :close-on-content-click="false"
          transition="none"
      >
        <template v-slot:activator="{ props }">
          <v-btn
              icon
              color="medium-emphasis"
              v-bind="props">
            <v-icon icon="mdi-dots-vertical"/>
          </v-btn>
        </template>

        <v-card min-width="300">
          <v-list>
            <AppDarkMode/>

            <v-divider/>

            <v-list-item
                prepend-icon="mdi-logout"
                title="Déconnexion"
                @click="logout"/>
          </v-list>
        </v-card>
      </v-menu>
    </v-no-ssr>
  </v-app-bar>
</template>


<style lang="scss">
@keyframes ring {
  0% { transform: rotate(0); }
  25% { transform: rotate(25deg); }
  50% { transform: rotate(-22deg); }
  75% { transform: rotate(15deg); }
  100% { transform: rotate(0deg); }
}



@keyframes pulse {
  0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(var(--v-theme-error), 0.7); }
  70% { transform: scale(1); box-shadow: 0 0 0 6px rgba(var(--v-theme-error), 0); }
  100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(var(--v-theme-error), 0); }
}

.notification-btn {
  &:hover {
    .v-icon {
      animation: ring 0.5s ease;
    }
  }
}

.notification-badge .v-badge__badge {
  animation: pulse 2s infinite;
}
</style>

<script lang="ts" setup>
import {useDisplay} from "vuetify";
import {mergeProps} from "vue";

const {mobile} = useDisplay()
const {drawer} = useApp()
const {user, getMe} = useAuth();
const {$customFetch} = useNuxtApp()
const userAuth = useCookie<BearerToken | null>('auth')

const menu = ref(false)
const notificationMenu = ref(false)

useUserSync().setupListeners()

function logout() {
  $customFetch('/api/logout', {
    method: 'post',
  }).finally(() => {
    userAuth.value = null;
    window.location.replace("/login")
  })
}
</script>
